module.exports = __webpack_public_path__ + "img/2.0223f5b1.webp";